import config from 'src/utils/config';

import ValueNode from '../ValueNode';
import Type from '../../Type';

import type Context from 'src/Context';
import type { BaseExpression, Expression, UiConfig } from 'src/types';

export interface StringNodeT extends BaseExpression {
    $type: 'StringNode';
    value: string;
}

export default class StringNode extends ValueNode<StringNodeT> {
    static TYPE = Type.Primitive({
        key: 'value',
    });

    static uiConfig: UiConfig = {
        ...config.presets.primitive,
        description: 'Plain text node',
    };

    validate(): string | null | undefined {
        if (typeof this.expression.value !== 'string' && this.expression.value != null)
            return 'value must be a string or null';
    }

    static getDefault(): Expression {
        return {
            ...super.getDefault(),
            value: '',
        };
    }

    async execute(context: Context): Promise<any> {
        return context.evaluate(this.expression.value);
    }
}
